import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export { preloadSpaceDetail } from '../src/preloadSpaceDetail.ts';
export {
	preloadPersonalSpaceDetail,
	preloadPersonalSpaceDetailsQuery,
} from '../src/preloadPersonalSpaceDetail.ts';
export type { preloadPersonalSpaceDetailsQuery$data } from '../src/__generated__/preloadPersonalSpaceDetailsQuery.graphql.ts';
// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { ConfluenceSpaceType } from '../src/space-target-select/SpaceTargetSelect.tsx';
export type { SpaceTargetOption } from '../src/space-target-select/SpaceTargetSelect.tsx';
export type { SpaceOption } from '../src/space-selector/space-select-modal/useSpacePicker.ts';
export const SpaceTargetSelect: LoadableType<{
	onChange: (value: string) => void;
	spaceTargetValue: string;
	menuPortalTarget?: HTMLElement;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceTargetSelect" */ '../src/space-target-select/SpaceTargetSelect.tsx'
			)
		).SpaceTargetSelect,
});
